import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';

const SW_RELOAD_KEY = 'sw-last-reload';
const SW_RELOAD_COOLDOWN_MS = 60_000; // 60 seconds

@Injectable({
  providedIn: 'root'
})
export class PromptUpdateService {

  private updateAvailable = false;

  constructor(private swUpdate: SwUpdate) {
    if (this.swUpdate.isEnabled) {
      // Verifica por atualizações a cada 5 minutos (antes era 1 min — muito agressivo)
      interval(1000 * 60 * 5).subscribe(() => {
        this.swUpdate.checkForUpdate();
      });
    }
  }

  public checkForUpdates(): void {
    this.swUpdate.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          break;
        case 'VERSION_READY':
          this.updateAvailable = true;
          this.applyUpdateSafely();
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.error(`Falha ao instalar a versão '${evt.version.hash}': ${evt.error}`);
          break;
      }
    });

    // Dispara verificação imediata ao iniciar (não espera os 5 min do interval)
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }
  }

  /**
   * Aplica a atualização com proteção contra reload loops.
   * Usa sessionStorage para garantir no máximo 1 reload por cooldown.
   */
  private applyUpdateSafely(): void {
    const lastReload = sessionStorage.getItem(SW_RELOAD_KEY);
    const now = Date.now();

    if (lastReload && (now - parseInt(lastReload, 10)) < SW_RELOAD_COOLDOWN_MS) {
      console.warn('Service Worker: update disponível mas reload ignorado (cooldown ativo).');
      return;
    }

    sessionStorage.setItem(SW_RELOAD_KEY, now.toString());
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }
}
